// extracted by mini-css-extract-plugin
export var divider = "_qb-0";
export var systemMessage = "_qb-1";